import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rounded mx-auto d-block login-logo"
  })
], -1)
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = {
  for: "index",
  class: "form-label"
}
const _hoisted_5 = {
  id: "index-help",
  class: "form-text"
}
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = {
  for: "umcn",
  class: "form-label"
}
const _hoisted_8 = {
  id: "umcn-help",
  class: "form-text"
}
const _hoisted_9 = {
  type: "submit",
  class: "btn btn-primary"
}

import { onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
import { SessionManager } from '@/services/session.manager'
import { MainService } from '@/services/main.service';
import { useHasActiveTest } from "@/hooks/hastest.hook";
import { AlertManager } from "@/services/alert.manager";
import Navigation from "@/components/Navigation.vue";
import { useTranslate } from "@/hooks/translate.hook";
import Swal from 'sweetalert2';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const index = ref<string>('')
const umcn = ref<string>('')

const router = useRouter()
const hasTest = useHasActiveTest()
const t = useTranslate()

async function onClick() {
  if (index.value == '' || umcn.value == '') {
    AlertManager.error(t('page.login.error.missing'))
    return
  }

  AlertManager.showLoading()
  MainService.login(index.value, umcn.value)
    .then(rsp => {
      if (rsp.data == undefined || "statusCode" in rsp.data) {
        Swal.close()
        AlertManager.error(t('page.login.error.bad'))
        return
      }
      SessionManager.saveAuth(rsp.data)
      Swal.close()
      router.push({
        path: '/list'
      })
    })
    .catch(e => {
      Swal.close()
      AlertManager.error(t('page.login.error.bad'))
    })
}

onBeforeMount(() => {
  // Return student to test list
  if (SessionManager.hasAuth()) {
    hasTest()
    MainService.getStudent().then(rsp => {
      // Student is already singed in
      router.push({
        path: '/list'
      })
    })
  }
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navigation, {
      show: false,
      logo: false
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        class: "form-responsive mx-auto mt-5",
        onSubmit: _withModifiers(onClick, ["prevent"]),
        autocomplete: "off"
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(t)("page.login.index.title")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "index",
            "aria-describedby": "index-help",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((index).value = $event))
          }, null, 512), [
            [_vModelText, index.value]
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("page.login.index.hint")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("page.login.umcn.title")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control key",
            id: "umcn",
            "aria-describedby": "umcn-help",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((umcn).value = $event))
          }, null, 512), [
            [_vModelText, umcn.value]
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)("page.login.umcn.hint")), 1)
        ]),
        _createElementVNode("button", _hoisted_9, _toDisplayString(_unref(t)("page.login.button")), 1)
      ], 32)
    ])
  ], 64))
}
}

})